import { NgModule } from '@angular/core';
// components

// modules
import { SharedModule, AngularCoreModule } from '@shared/index';

// 3rd party libraries
import { NgSelectModule } from '@ng-select/ng-select';
import {
	BsDropdownModule,
	TooltipModule,
	ModalModule,
	BsDatepickerModule,
	PopoverModule,
	TimepickerModule,
	ButtonsModule,
	SortableModule,
	TabsModule,
} from 'ngx-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { DeviceDetectorModule } from 'ngx-device-detector';

@NgModule({
	imports: [
		SharedModule,
		AngularCoreModule,
		NgSelectModule,
		NgxMaskModule,
		BsDatepickerModule.forRoot(),
		TimepickerModule.forRoot(),
		TooltipModule.forRoot(),
		ModalModule.forRoot(),
		DeviceDetectorModule.forRoot(),
	],
	exports: [],
	declarations: [],
	entryComponents: [],
})
export class CoreComponentsModule {}
